
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_oqq4a_17",
  "arrow": "awsui_arrow_18eso_oqq4a_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_oqq4a_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_oqq4a_77",
  "has-caret": "awsui_has-caret_18eso_oqq4a_113",
  "placeholder": "awsui_placeholder_18eso_oqq4a_116",
  "pressed": "awsui_pressed_18eso_oqq4a_132",
  "disabled": "awsui_disabled_18eso_oqq4a_138",
  "in-filtering-token": "awsui_in-filtering-token_18eso_oqq4a_77",
  "readonly": "awsui_readonly_18eso_oqq4a_159",
  "invalid": "awsui_invalid_18eso_oqq4a_180",
  "warning": "awsui_warning_18eso_oqq4a_189",
  "custom-option": "awsui_custom-option_18eso_oqq4a_198",
  "inline-tokens": "awsui_inline-tokens_18eso_oqq4a_203",
  "grouped": "awsui_grouped_18eso_oqq4a_206",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_oqq4a_212",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_oqq4a_216",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_oqq4a_222",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_oqq4a_226",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_oqq4a_230",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_oqq4a_236",
  "grouped-with-action": "awsui_grouped-with-action_18eso_oqq4a_240"
};
  